var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInsights = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v29h-8zm3-1a1 1 0 0 0-1 1v27h4V3a1 1 0 0 0-1-1zM2 17a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v15H2zm3-1a1 1 0 0 0-1 1v13h4V17a1 1 0 0 0-1-1zM25 8a3 3 0 0 0-3 3v21h8V11a3 3 0 0 0-3-3zm-1 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v19h-4z",
  clipRule: "evenodd"
})));
export default SvgInsights;